import {ADD_PurchaseOrder_ROW_MOVEMENTS_TABLE,UPDATE_PurchaseOrder_ROW_MOVEMENTS_TABLE,Reset_PurchaseOrder_ROW_MOVEMENTS_TABLE,DELETE_PurchaseOrder_DETAIL_PurchaseOrder_REGISTER} from '../../../../constants/ActionTypes'

const InitialState = {
    PurchaseOrderHeader:[]
}

function PurchaseOrder(state = InitialState, action) {
    switch (action.type) {
        case ADD_PurchaseOrder_ROW_MOVEMENTS_TABLE:
        return{
            ...state,
            PurchaseOrderHeader:[...state.PurchaseOrderHeader,action.payload]          
        }

        case UPDATE_PurchaseOrder_ROW_MOVEMENTS_TABLE:
            let NewData=state.PurchaseOrderHeader.map((data, index)=>(index != action.payload.index ?  data : ({
                ...data,
                ...action.payload.data
              })));
              return {
                  ...state,
                  PurchaseOrderHeader:NewData
        }
        case Reset_PurchaseOrder_ROW_MOVEMENTS_TABLE:
            return {
                ...state,
                PurchaseOrderHeader:[]
            }
        case DELETE_PurchaseOrder_DETAIL_PurchaseOrder_REGISTER:
            const productId  = action.payload;
            return {
                ...state,
                PurchaseOrderHeader: state.PurchaseOrderHeader.filter(x => x.productId !== productId)
            }
        default:
          return state
    }

}

export default PurchaseOrder;